module.exports = __webpack_public_path__ + "img/whatsapp.e9d08d30.svg";